'use client';

import { useState } from 'react';
import Image from 'next/image';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus('loading');

    const res = await fetch('/api/newsletter/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (res.ok) {
      setStatus('success');
      setMessage(data.message || "You're subscribed!");
      setEmail('');
    } else {
      setStatus('error');
      setMessage(data.error || 'Something went wrong.');
    }
  }

  return (
    <div className="newsletter-box">
      <div className="nl-icon">
        <Image src="/newsletter-art.png" alt="The Daily Marquee" width={400} height={225} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
      </div>
      <h3>THE DAILY MARQUEE</h3>
      <p>Top entertainment stories delivered every morning straight to your inbox.</p>
      {status === 'success' ? (
        <p style={{ color: '#4caf50', fontSize: 14 }}>{message}</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={status === 'loading'}>
            {status === 'loading' ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
          </button>
          {status === 'error' && (
            <p style={{ color: '#e74c3c', fontSize: 12, marginTop: 8 }}>{message}</p>
          )}
        </form>
      )}
    </div>
  );
}
